var s = Object.defineProperty;
var a = (i, e, t) => e in i ? s(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var o = (i, e, t) => (a(i, typeof e != "symbol" ? e + "" : e, t), t);
import "fabric";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import { calcCalloutScale as n } from "./index.es252.js";
import { GenericCalloutBox as u } from "./index.es170.js";
class x extends u {
  constructor(t) {
    super({ ...t, draggable: !1, perPixelTargetFind: !0 });
    // default. not controlled by props
    o(this, "renderedCalloutBox");
    o(this, "hasStatusOuterBox", !0);
    o(this, "hasLeaderLine", !1);
    o(this, "hasSourcePoint", !1);
    o(this, "SupportedStatuses", ["select", "idle"]);
    // controlled via props
    o(this, "poiInfo");
    this.poiInfo = t.poiInfo, this.updateStatusOuterBox();
  }
  computeContentSize() {
    const t = this._objects[0];
    if (!t)
      return { width: 0, height: 0 };
    const r = n(this.map.getZoom(), "RoadLabel");
    return {
      width: r * ((t.width || 0) + 6),
      height: r * ((t.height || 0) + 6)
    };
  }
  updateStatusOuterBox() {
    var r;
    const t = this.computeContentSize();
    return (r = this.statusOuterBox) == null || r.set({
      rx: this.poiInfo.styleConfig.bgCornerRadius,
      ry: this.poiInfo.styleConfig.bgCornerRadius,
      width: t.width,
      height: t.height,
      angle: this.poiInfo.angle - 90,
      centeredRotation: !0,
      left: 0,
      top: 0
    }), this.statusOuterBox;
  }
  syncCalloutBoxConfig() {
  }
}
export {
  x as RoadLabelCalloutBox
};
//# sourceMappingURL=index.es172.js.map
